// extracted by mini-css-extract-plugin
module.exports = {"container":"NoResults__container___3LSVi"};